import { useRef, useState, useLayoutEffect, useCallback } from 'react'
import { Label } from 'types/Label'
import { LabelChip } from 'components/data/LabelChip/LabelChip'
import * as Styled from './CardLabelContainer.styles'

interface CardLabelContainerProps {
  labels: Label[]
}

const CardLabelContainer = ({ labels }: CardLabelContainerProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const chipRefs = useRef<HTMLDivElement[]>([])
  const moreChipRef = useRef<HTMLDivElement | null>(null)
  const [visibleCount, setVisibleCount] = useState(labels.length)

  const calculateVisibleCount = useCallback(() => {
    if (!containerRef.current || !moreChipRef.current) {
      return
    }

    const containerWidth = containerRef.current.offsetWidth
    const moreChipWidth = moreChipRef.current.offsetWidth
    let totalWidth = 0
    let fitCount = 0

    const availableWidth = containerWidth - moreChipWidth

    for (let i = 0; i < chipRefs.current.length; i += 1) {
      const chip = chipRefs.current[i]
      if (chip) {
        const chipWidth = chip.offsetWidth
        if (totalWidth + chipWidth > availableWidth) {
          break
        }
        totalWidth += chipWidth
        fitCount += 1
      }
    }

    setVisibleCount(fitCount)
  }, [])

  useLayoutEffect(() => {
    calculateVisibleCount()
    window.addEventListener('resize', calculateVisibleCount)
    return () => {
      window.removeEventListener('resize', calculateVisibleCount)
    }
  }, [calculateVisibleCount, labels])

  chipRefs.current = []

  return (
    <Styled.CardLabelContainer ref={containerRef}>
      {labels.map(({ id, color, name, nameTranslations }, i) => (
        <Styled.ChipWrapper
          key={id}
          $visible={i < visibleCount}
          ref={(el) => {
            if (el) {
              chipRefs.current[i] = el
            }
          }}
        >
          <LabelChip
            color={color}
            name={name}
            nameTranslations={nameTranslations}
            marginRight={6}
          />
        </Styled.ChipWrapper>
      ))}

      <Styled.MoreChipWrapper
        $visible={visibleCount < labels.length}
        ref={moreChipRef}
      >
        <LabelChip
          name={`+${labels.length - visibleCount}`}
          color='#eeeeee'
          nameTranslations={[]}
        />
      </Styled.MoreChipWrapper>
    </Styled.CardLabelContainer>
  )
}

export { CardLabelContainer }
